





























import { Component, Vue } from 'vue-property-decorator'
import images from '@/data/images'
import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/button.min.css'
import 'semantic-ui-css/components/icon.min.css'

interface Data {
  title: string,
  subtitle: string,
  image: string,
  status: string,
  description: string,
  home: string,
  background: string | undefined
}

const glitchedDatasets: Data[] = [
  {
    title: '%',
    subtitle: 'Hxppy thxughts.',
    image: images.core.lcWhiteCircleGlitch,
    status: '404',
    description: 'Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of my head. Get out of Get. Out. Of. My. Head. Get out of my head before I do what I know is best for you. Get out of my head before I listen to everything she said to me. Get out of my head before I show you how much I love you. Get out of my head before I finish writing this poem. But a poem is never actually finished. It just stops moving.',
    home: 'GET OUT',
    background: 'linear-gradient(160deg, #000f1a, #001f33, #002e4d 75%)'
  },
  {
    title: '␡',
    subtitle: 'Save me',
    image: images.core.lcWhiteCircleGlitch,
    status: '404',
    description:
      "The colors, they won't... Bright, bea�t�ful c�l�rs Flash�ng, exp�nd�ng, piercing... Red, green, blue An ndless CACOPHONY Of meaningless noise. The noise, it won't STOP. Viol nt, grating w vef rms. Sq e king, screech ng, piercing. SINE, COSINE, TANGENT. Like play�ng a ch�lkboard on a t�rntable. Like playing a KNIFE on a BREATHING RIBCAGE. �n �ndl�ss p��m Of m��n�ngl�ss... Delete Her.",
    home: 'SAVE ME',
    background: 'linear-gradient(160deg, #001a00, #003300, #004d00 75%)'
  },
  {
    title: '◎ ◉ ◎',
    subtitle: 'Open your third eye',
    image: images.core.lcWhiteCircleGlitch,
    status: '404',
    description: "I can feel the tenderness of her skin through the knife, as if it were an extension of my sense of touch. My body nearly convulses. There's something incredibly faint, deep down, that screams to resist this uncontrollable pleasure. But I can already tell that I'm being pushed over the edge. I can't...I can't stop myself.",
    home: 'V2FrZSBVcA==',
    background: 'linear-gradient(160deg, #1a0000, #330000, #4d0000 75%)'
  }
]

@Component
export default class LCNotFound extends Vue {
  controls = false
  title = '404'
  subtitle = 'Not found. You seem to have gotten lost.'
  image: string = images.core.lcNotFoundFox
  status = 'Whoops'
  description = 'Maybe you took a wrong turn. Maybe a cheeky wizard lied to you... Whatever it was, it is not here anymore...'
  home = 'Back to Home'
  background: string | undefined = undefined

  purify () {
    this.title = '404'
    this.subtitle = 'Not found. You seem to have gotten lost.'
    this.image = images.core.lcNotFoundFox
    this.status = 'Whoops'
    this.description = 'Maybe you took a wrong turn. Maybe a cheeky wizard lied to you... Whatever it was, it is not here anymore...'
    this.home = 'Back to Home'
    this.background = 'linear-gradient(160deg, #190d3f, #29166a, #4412a1, #60136c 75%)'
    this.updateBackground()
  }

  glitchify (ix: number) {
    const glitched: Data = glitchedDatasets[ix]
    this.title = glitched.title
    this.subtitle = glitched.subtitle
    this.image = glitched.image
    this.status = glitched.status
    this.description = glitched.description
    this.home = glitched.home
    this.background = glitched.background
    this.updateBackground()
  }

  updateBackground () {
    if (!this.background) return
    const html = document.querySelector('html')
    if (!html) return
    html.style.background = this.background
  }

  created () {
    const glitch = Math.floor(Math.random() * 10) === 0
    if (!glitch) return
    this.glitchify(Math.floor(Math.random() * glitchedDatasets.length))
  }

  mounted () {
    this.updateBackground()
  }
}
